export default "__VITE_ASSET__JcQqaQJC__"